(function () {
  "use strict";
  var state = {
    locked: false,
    scrollY: 0,
    hadScrollLock: false,
    previousTop: ""
  };

  function getQuickCartWrapper() {
    return document.querySelector(".quick-cart__wrapper");
  }

  function isQuickCartOpen() {
    var wrapper = getQuickCartWrapper();
    return !!(wrapper && wrapper.classList.contains("active"));
  }

  function lockBodyForQuickCart() {
    if (state.locked) return;

    var body = document.body;
    state.scrollY = window.pageYOffset || window.scrollY || 0;
    state.hadScrollLock = body.classList.contains("scroll-lock");
    state.previousTop = body.style.top || "";

    if (!state.hadScrollLock) {
      body.classList.add("scroll-lock");
    }

    if (!body.style.top) {
      body.style.top = "-" + state.scrollY + "px";
    }

    state.locked = true;
  }

  function unlockBodyForQuickCart() {
    if (!state.locked) return;

    var body = document.body;

    if (!state.hadScrollLock) {
      body.classList.remove("scroll-lock");
    }

    if (body.style.top === "-" + state.scrollY + "px") {
      body.style.top = state.previousTop;
    }

    if (!state.hadScrollLock) {
      window.scrollTo(0, state.scrollY);
    }

    state.locked = false;
  }

  function sync() {
    if (isQuickCartOpen()) {
      lockBodyForQuickCart();
    } else {
      unlockBodyForQuickCart();
    }
  }

  function init() {
    var observer = new MutationObserver(sync);
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["class"]
    });

    window.addEventListener("pageshow", sync);
    window.addEventListener("resize", sync, { passive: true });

    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "visible") sync();
    });

    sync();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
